import styled from 'styled-components'

export const StyledNoData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.white[500]};
  padding: ${props => props.theme.spacing.xxlarge} 25%;
  text-align: center;

  span {
    font-size: ${props => props.theme.font.medium};
    opacity: 0.6;
    margin-top: ${props => props.theme.spacing.xlarge};
  }
`
